import { render, staticRenderFns } from "./BotStatus.vue?vue&type=template&id=4d2114d2&"
import script from "./BotStatus.vue?vue&type=script&lang=ts&"
export * from "./BotStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports